<!-- eslint-disable vue/no-parsing-error -->
<template>
  <div class="introduce w">
    <Row class="component-title">
      <Col span="24">中心介绍</Col>
    </Row>
    <Row class="introduce-content content1">
      <Col span="16" class="h-full fc-transparent">.</Col>
      <Col span="8" class="h-full relative">
        <div class="h-auto w-full introduce-detail absolute pin-b pin-l">
          <div class="detail-text">
            <h6>生物信息库</h6>
            <div>
              收集包含与样本相关的所有临床信息、随访信息、样本动态信息和样本使用反馈信息等内容，用于支持科学研究及其相关数据分析。
            </div>
          </div>
          <Button :to="'information'">了解更多</Button>
        </div>
      </Col>
    </Row>
    <Row class="introduce-content content2">
      <Col span="8" class="h-full relative">
        <div class="h-auto w-full introduce-detail absolute pin-b pin-l">
          <div class="detail-text">
            <h6>生物样本库</h6>
            <div>
              标准化收集、处理、储存和应用健康和疾病生物体样本以及与这些生物样本相关的临床信息及随访资料。
            </div>
          </div>
          <Button :to="'sample'">了解更多</Button>
        </div>
      </Col>
      <Col span="16" class="h-full fc-transparent">.</Col>
    </Row>
  </div>
</template>

<script>
export default {
  name: 'IntroduceComponent',
  props: {},
  mixins: [],
  components: {},
  data() {
    return {
      hooperSettings: {
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
        centeredSlides: true,
        // effect: 'fade',
        autoplay: {
          delay: 3500,
          disableOnInteraction: false
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
        // navigation: {
        //   nextEl: '.swiper-button-next',
        //   prevEl: '.swiper-button-prev'
        // }
      }
    }
  },
  computed: {},
  mounted() {},
  methods: {}
}
</script>

<style lang="scss" scoped>
@import '@/styles/css_base.scss';
.introduce {
  .ivu-btn {
    padding: 0.625vw 1.93vw; //12px 37px;
    font-size: 0.73vw; //14px;
    line-height: 1.43;
    color: #3a99a7;
    border-radius: 4px;
    border: 1px solid #3a99a7;
    transition: all 1s;
    -moz-transition: all 1s;
    -webkit-transition: all 1s;
    -o-transition: all 1s;
    &:hover {
      color: $c-white;
      background-color: #3a99a7;
      border: 1px solid $c-white;
    }
  }
  .introduce-content {
    height: 22.19vw; //426px;
    background-size: cover;
    background-repeat: no-repeat;
    margin-bottom: 3.125vw; //60px;
  }

  .introduce-detail {
    background-color: #3a99a7;
    padding: 2.7vw 2.4vw 2.08vw 2.8125vw; //52px 46px 40px 54px;
    border-radius: 0.78vw 0.78vw 0 0; //15px 15px 0 0;
  }
  .detail-text {
    color: $c-white;
    font-size: 0.83vw; //16px;
    line-height: 1.375;
    letter-spacing: 1px;
    margin-bottom: 1.875vw; //36px;
    h6 {
      font-size: 1.24vw; //24px;

      margin-bottom: 0.83vw; //16px;
    }
  }
  .content1 {
    background-image: url('/static/images/background/introduce1.png');
    padding-right: 4.17vw; //80px;
  }
  .content2 {
    background-image: url('/static/images/background/introduce2.png');
    padding-left: 4.17vw; //80px;
    .introduce-detail {
      background-color: #3aa69f;
    }
    .ivu-btn {
      color: #3aa69f;
      border: 1px solid #3aa69f;
      transition: all 1s;
      -moz-transition: all 1s;
      -webkit-transition: all 1s;
      -o-transition: all 1s;
      &:hover {
        color: $c-white;
        background-color: #3aa69f;
        border: 1px solid $c-white;
      }
    }
  }
}
</style>
